import { FieldType } from './types';

type GetFieldTypeParams = {
    getAvailableFields: () => FieldType[];
    field: string;
  };

export const getFieldType = ({ getAvailableFields, field }: GetFieldTypeParams ) => {
    const foundField = getAvailableFields().find( f => f.value === field );
    return foundField?.type || 'string';
};

/**
 * Recursively removes properties whose value is null or undefined (or '').
 */
export const removeNulls = <T>( obj: T ): T => {
  if ( obj === null || obj === undefined ) return obj as T;

  if ( Array.isArray( obj )) {
    // Clean each element, then filter out any that collapsed to null/undefined
    return obj
      .map( removeNulls )
      .filter( v => v !== null && v !== undefined ) as unknown as T;
  }

  if ( typeof obj === 'object' ) {
    return Object.entries( obj ).reduce(( acc, [ key, value ]) => {
      const cleaned = removeNulls( value );
      if (
        cleaned !== null &&
        cleaned !== undefined &&
        cleaned !== '' // ⬅ remove this line if you want to keep empty strings
      ) {
        ( acc as any )[key] = cleaned;
      }
      return acc;
    }, {} as any ) as T;
  }

  return obj;
};